module.exports = __webpack_public_path__ + "static/headerhero-185225ce15e655525ebf7cf592fdf52f.jpg";